<template>
  <div class='mt-1'>
    <b-modal
      ref='accept-information-tab'
      id='accept-information-tab'
      hide-footer
      hide-header
      header-bg-variant='info'
      header-text-variant='light'
      size='lg'
      @show='showModal()'
      no-close-on-esc
      no-close-on-backdrop
    >
      <section class='modal-font-family'>
        <section class='d-flex justify-content-end w-100 mb-1'>
          <span class="mr-2 text-checkbox">Não exibir novamente, mas estou ciente das informações e declaro estar de acordo.</span>
          <b-form-checkbox
            id="agreeWithInformation"
            v-model="userAwareOfInformation.awareOfInformation"
            name="agreeWithInformation"
            :value="true"
            :unchecked-value="false"
          >
          </b-form-checkbox>
        </section>

        <section>
          <p class="text-center title-attention mb-1">Atenção</p>
          <p class="message-title">
            O HO Fácil Web é um sistema colaborativo que reúne informações da internet e dos arquivos anexados pelos
            usuários,
            oferecendo exatamente o que precisam para fundamentar seus documentos. Entre as fontes consultadas estão
            <a href="https://chemicalsafety.ilo.org/" target="_blank">ILO Chemical Safety</a>,
            <a href="https://pubchem.ncbi.nlm.nih.gov/" target="_blank"> PubChem</a>,
            <a href="https://www.cdc.gov/niosh/" target="_blank"> CDC/NIOSH</a>,
            <a href="https://gestis-database.dguv.de/" target="_blank"> GESTIS</a>,
            entre outras.
          </p>
        </section>

        <section>
          <span class="text-btn">Estou ciente das informações e declaro estar de acordo ao continuar.</span>
        </section>

        <section class='mt-4'>
          <base-button
            @click="sendUserAwareOfInformation()"
            class='w-100 btn-add d-flex align-items-center justify-content-center'
          >
            <span> Continuar </span>
          </base-button>
        </section>
      </section>
    </b-modal>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { physicalProductStates } from '@/mocks/physicalProductStates'
import { optionsDegreeOfDust } from '@/mocks/optionsDegreeOfDust'
import { geolocation } from '@/services/ipGeolocation'

export default {
  name: 'AcceptInformationTab',
  components: {},
  props: {},
  data() {
    return {
      userAwareOfInformation: {
        userId: null,
        awareOfInformation: false,
        tab: null,
        clickedContinue: false,
        location: null,
      }
    }
  },
  async mounted() {
    try {

    } catch (e) {
    }
  },
  computed: {
    user() {
      return this.$store.getters['user/current']
    }
  },
  methods: {
    ...mapActions('userAwareOfInformation', {
      handleCreate: 'handleCreate',
    }),
    async showModal() {
      try {
        this.userAwareOfInformation = {
          userId: this.user.id,
          awareOfInformation: false,
          tab: 'PreventionistLimits',
          clickedContinue: false,
          location: null,
        }
      } catch (e) {

      }
    },
    async getLocation(){
      try {
        let location = {}
        const { data, status } = await geolocation()
        if(status === 200) {
          location = data
        }
        return location
      } catch (e) {

      }
    },


    async sendUserAwareOfInformation() {
      try {
        this.closeModal()
        this.userAwareOfInformation.clickedContinue = true
        this.userAwareOfInformation.location = await this.getLocation()
        await this.handleCreate(this.userAwareOfInformation)
      } catch (e) {
        console.log(e)
      }
    },

    closeModal() {
      this.$bvModal.hide('accept-information-tab')
    }
  },
  created() {
  }
}
</script>
<style lang='scss' scoped>
.btn-add {
  background: var(--navy-blue) !important;
  border-radius: 6.25px !important;
  border: 1px solid var(--navy-blue) !important;

  span {
    color: #ffffff;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
  }
}

.text-checkbox {
  font-size: 15px;
  font-weight: 600;
  color: #262626;
}

.text-btn {
  font-size: 15px;
  font-weight: 700;
  color: #262626;
}

.message-title {
  font-weight: 400;
  color: #808080;
  font-size: 15px;

  a {
    font-weight: 400;
    color: #808080;
    text-decoration: underline;
  }
}

.title-attention {
  font-weight: 600;
  color: #022245;
  font-size: 22px;
}
</style>
